export const UPDATE_MARKETPLACE_LIST = "UPDATE_MARKETPLACE_LIST";
export const UPDATE_MARKETPLACE_TOTAL_ITEMS = "UPDATE_MARKETPLACE_TOTAL_ITEMS";
